import React from "react";
import { Link, useLocation } from "react-router-dom";

const TabMenuChain1 = () => {
  const location = useLocation();

  return (
    <>
      <ul>
        <li>
          <Link
            to="/deposit/pom"
            className={`${location.pathname == "/" ? "active" : location.pathname == "/deposit/pom" ? "active" : ""}`}
          >
            Deposit
          </Link>
        </li>
        <li>
          <Link
            to="/withdraw/pom"
            className={`${location.pathname == "/withdraw/pom" ? "active" : ""}`}
          >
            Withdraw
          </Link>
        </li>
      </ul>
    </>
  );
};

export default TabMenuChain1;
